"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const resize_observer_1 = require("@juggle/resize-observer");
const classnames_1 = __importDefault(require("classnames"));
const side_panel_1 = require("@alfalab/core-components/side-panel");
const component_context_1 = require("../context/component.context");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * <SidePanel.Actions>
 *
 * Блок с действиями для SidePanel.
 *
 * Цвет фона перекрашивается, если появляется скролл на SidePanel.Body.
 */
const Actions = ({ CoreSidePanel = side_panel_1.SidePanel.Footer, className, children, withBodyScrollableClassName = '', dataTestId, }) => {
    const { hasScroll } = (0, react_1.useContext)(component_context_1.SidePanelContext);
    const { setActionsHeight } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const backdropRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a;
        setActionsHeight(((_a = backdropRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0);
    });
    (0, react_1.useEffect)(() => {
        const observer = new resize_observer_1.ResizeObserver(([{ target }]) => {
            setActionsHeight(target.clientHeight || 0);
        });
        const backdrop = backdropRef.current;
        if (backdrop) {
            observer.observe(backdrop);
        }
        return () => {
            if (backdrop) {
                observer.unobserve(backdrop);
            }
        };
    }, [setActionsHeight]);
    const footerContent = ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: index_module_css_1.default.backdrop, ref: backdropRef }), (0, jsx_runtime_1.jsx)("div", { className: index_module_css_1.default.innerWrapper, children: children })] }));
    const footerProps = {
        className: (0, classnames_1.default)(index_module_css_1.default.component, {
            [index_module_css_1.default.withBodyScrollable]: hasScroll,
            [withBodyScrollableClassName]: hasScroll,
        }, className),
        dataTestId,
        sticky: true,
    };
    return (0, jsx_runtime_1.jsx)(CoreSidePanel, Object.assign({}, footerProps, { children: footerContent }));
};
exports.Actions = Actions;
